import classnames from "classnames";
import React from "react";
import scroll from "scroll";
import * as styles from "./index.module.scss";

export default ({ children, color, narrow, ...headerStyles }) => (
  <div
    className={classnames(
      styles.HeaderTitleWrapper,
      "noselect",
      narrow && styles.Narrow,
    )}
    style={{ color: color }}
    onClick={() => {
      console.log("scroll");
      scroll.top(0);
    }}
  >
    <span />
    <span className={styles.HeaderTitle} style={headerStyles} role="heading">
      {children}
    </span>
  </div>
);
